var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.fullscreenLoading,
          expression: "fullscreenLoading",
          modifiers: { fullscreen: true, lock: true }
        }
      ],
      staticClass: "verify-box",
      staticStyle: { width: "400px" }
    },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "拆工单理赔",
            visible: true,
            "before-close": _vm.onCloseDialog,
            width: 380
          }
        },
        [
          _c(
            "el-form",
            { staticStyle: { "margin-left": "10%" } },
            [
              _c("el-form-item", { attrs: { label: "工单id：" } }, [
                _vm._v("\n        " + _vm._s(_vm.resData.work_id) + "\n      ")
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "无实物拆包数量：" } }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.resData.no_back_num) + "\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "拆分件数：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      type: "number",
                      placeholder: "输入拆分件数",
                      size: "mini"
                    },
                    model: {
                      value: _vm.form.num,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "num", $$v)
                      },
                      expression: "form.num"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onCloseDialog } }, [
                    _vm._v("取 消")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.submitData }
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a1a08c5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a1a08c5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/claims/components/Split.vue
// module id = null
// module chunks = 